 // For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});


var DesignStrip = 2;
export function DesignButton1(event) {
	if (DesignStrip !== 1) {
		$w("#DesignStrip1").expand()
		$w("#DesignStrip2").collapse()
		DesignStrip = 1;
	}
}
export function DesignButton2(event) {
	if (DesignStrip !== 2) {
		$w("#DesignStrip2").expand()
		$w("#DesignStrip1").collapse()
		DesignStrip = 2;
	}
}


var ColorStrip = 1;
export function ColorButton(event) {
	var num = parseInt(event.target.id.charAt(5), 10)
	if (ColorStrip === num) {
		return;
	}
	$w("#StripColor" + ColorStrip).collapse()
	ColorStrip = num
	$w("#Strip" + event.target.id).expand()
}